// ** React Imports
import React from 'react';
// ** Third Party Import
import Lottie from 'lottie-react';
// ** Animated Lottie JSON Import
// import AiVariant3StarIcon from './json/ai-variant-3-star-icon.json';
import AiVariant3StarIcon from '../../../../../../../assets/json/lottieanimation/ai-variant-3-star-icon.json';

/**
 * @description Animated icon of AI variant 3 star icon to show loading state
 * @returns React Component
 */
const EmailPreviewAiVariantSkeleton: React.FC = () => (
  <div className="email-preview-ai-variant-skeleton">
    <Lottie
      animationData={AiVariant3StarIcon}
      loop
      className="ai-3-star-animated-icon"
    />

    <div className="ai-variant-loading-text-section">
      <span className="text-content">Your custom email is on its way,</span>
      <span className="text-content">just a moment more, it won't delay!</span>
    </div>
  </div>
);

export default EmailPreviewAiVariantSkeleton;
